// extracted by mini-css-extract-plugin
export default {"interiorImageContainer":"aVfVJ","interiorImage":"KDitK"};